import { render, staticRenderFns } from "./HomeScene.vue?vue&type=template&id=878086da&"
import script from "./HomeScene.vue?vue&type=script&lang=js&"
export * from "./HomeScene.vue?vue&type=script&lang=js&"
import style0 from "./HomeScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports